import React, { ComponentType, FC } from 'react';
import { I18nContext } from './i18n-context';
import { I18nModel, WithI18nOuterProps, WithI18nProps } from './types';

export function withI18nConsumer<P extends object>(Component: ComponentType<P & WithI18nProps>): FC<WithI18nOuterProps<P>> {
  return (props: WithI18nOuterProps<P>) => (
    <I18nContext.Consumer>
      {(i18n: I18nModel) => <Component i18n={i18n} {...props as P} />}
    </I18nContext.Consumer>
  );
}

// withI18nProvider is exported only for testing
export function withI18nProvider<P extends object>(Component: ComponentType<P>, i18n: I18nModel): FC<P> {
  return (props: P) => (
    <I18nContext.Provider value={i18n}>
      <Component {...props} />
    </I18nContext.Provider>
  );
}

export function withI18n<P extends object>(Component: ComponentType<P & WithI18nProps>, i18n: I18nModel): FC<WithI18nOuterProps<P>> {
  return withI18nProvider(withI18nConsumer(Component), i18n);
}
